import { CheckCircle2, Trash2, XCircle } from 'lucide-react';
import type { CalendarSession } from '@/lib/api';

type SessionStatus = CalendarSession['status'];

export function getSessionStatusLabel(
  status: SessionStatus,
  options?: { completedLabel?: string }
): string {
  const completedLabel = options?.completedLabel ?? 'Completed';
  switch (status) {
    case 'completed':
      return completedLabel;
    case 'skipped':
      return 'Skipped';
    case 'deleted':
      return 'Deleted';
    case 'missed':
      return 'Missed';
    case 'planned':
    default:
      return 'Planned';
  }
}

export function getSessionStatusIcon(status: SessionStatus) {
  switch (status) {
    case 'completed':
      return CheckCircle2;
    case 'skipped':
      return XCircle;
    case 'deleted':
      return Trash2;
    case 'missed':
    case 'planned':
    default:
      return null;
  }
}
